export const visit = (vm, at) => {
at({ "en": { "growth-onboarding-beacon": { "taskTimeEstimate": { "one": "About {{ count }} min", "other": "About {{ count }} mins" }, "tooltip": { "learnMore": "Select to learn more about {{ title }}" }, "dismissal": { "buttonText": "Don't show these tips" } } } });
};